module.exports = __webpack_public_path__ + "static/media/kerestir.20bec3cb.jpg";